import Envelope from '../../src/legacy/Envelope';
export default Envelope;
